import App from './modules/app/App';


(new App()).start();
